import { useEffect } from 'react'
import { useFormikContext } from 'formik'

import {
  TASK_FORM_ID_FIELD_NAME,
  TASK_FORM_TITLE_FIELD_NAME,
  TASK_FORM_TYPE_FIELD_NAME,
} from '../../../TaskForm.constants'

export function useTypeFieldChange() {
  const { setFieldValue, touched, values } = useFormikContext()

  useEffect(() => {
    if (
      !touched[TASK_FORM_TITLE_FIELD_NAME] &&
      !values[TASK_FORM_ID_FIELD_NAME] &&
      values[TASK_FORM_TYPE_FIELD_NAME]?.name
    ) {
      // After load need to set title field value to first item name
      setFieldValue(
        TASK_FORM_TITLE_FIELD_NAME,
        values[TASK_FORM_TYPE_FIELD_NAME].name
      )
    }
  }, [values[TASK_FORM_TYPE_FIELD_NAME]])
}
